/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"
import "./layout.css"
import "./blocks/style.css"

const Layout = ({ children, pageID = 0, slug = '', customFooter = null }) => {
  return (
    <>
      <Header slug={slug} />
      <main>{children}</main>
      {
        customFooter ? customFooter : <Footer pageID={pageID} />
      }
      <script id="business-json-ld" type="application/ld+json" 
      dangerouslySetInnerHTML={
        { 
          __html:`{
            "@context": "https://schema.org",
            "@type": "PlasticSurgery",
            "name": "Adam J. Scheiner, M.D.",
            "image": "https://adamscheinermd.com/images/logo.jpg",
            "@id": "https://adamscheinermd.com/",
            "url": "https://adamscheinermd.com/",
            "telephone": "1(813)367-1915",
            "priceRange": "$$-$$$",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "4303 N. Gomez Ave",
              "addressLocality": "Tampa",
              "addressRegion": "FL",
              "postalCode": "33607",
              "addressCountry": "US"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 27.9803097,
              "longitude": -82.4905615
            },
            "openingHoursSpecification": [{
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday"
              ],
              "opens": "08:00",
              "closes": "17:00"
            },{
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Friday",
              "opens": "08:00",
              "closes": "14:00"
            }],
            "sameAs": [
              "https://www.facebook.com/adamscheinermd",
              "https://www.instagram.com/adam_scheiner_md/",
              "https://www.linkedin.com/company/adam-scheiner-m-d/",
              "https://pin.it/3FpGPPe",
              "https://www.youtube.com/channel/UCuYqhH9EXuAmKsgmvLTZG3Q"
            ] 
          }`
        }
      }
      />
    </>
  )
}

Layout.propTypes = {
  pageID: PropTypes.number,
  children: PropTypes.node.isRequired,
  slug: PropTypes.string,
}

export default Layout
